import {getDataWithPromise, Globals } from "../globals";
import { handleAjaxError} from './ErrorHandlingFunctions'
import { getParamList } from "./BaseDataFns";

export const getChildDataWithDetails = ( enc_child_id, flagArray, onComplete ) =>
{
    const url = Globals.APIFolder + '/eyfsn/school/any/user/' + enc_child_id + '/details' ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
